import { Row, Col, Form, InputGroup } from 'react-bootstrap';

const DebtRow = (props) => {
  return (
    <Row className='item-row'>
      <Col  xs={11} md={5} lg={4}>
        <Form.Control
          disabled
          type="text"
          value="Debt"
        />
      </Col>
      <Col  xs={11} md={5} lg={4}>
        <Form.Control
          disabled
          type="text"
        />
      </Col>
      <Col  xs={11} md={5} lg={2}>
        <InputGroup>
          <InputGroup.Text>£</InputGroup.Text>
          <Form.Control
            disabled
            type="number"
            value={Number(props.debtData.manual?props.debtData.totalPerMonthIndividual
              :props.debtData.totalPerMonthOverall).toFixed(2)}
          />
        </InputGroup>
      </Col>
      <Col  xs={11} md={5} lg={2}>
        <InputGroup>
          <InputGroup.Text>£</InputGroup.Text>
          <Form.Control
            disabled
            type="number"
            value={Number(props.debtData.manual?props.debtData.totalPerWeekIndividual
              :props.debtData.totalPerWeekOverall).toFixed(2)}
          />
        </InputGroup>
      </Col>
      <Row>&nbsp;</Row>
    </Row>
  )
}

export default DebtRow;